import { render, staticRenderFns } from "./user-types.page.vue?vue&type=template&id=c771c9e8"
import script from "./user-types.page.vue?vue&type=script&lang=ts"
export * from "./user-types.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports